import { useState } from 'react';
import { toast } from 'react-toastify';
import UseContext from 'hooks/useContext';
import useModal from 'components/modal/useModal';
import ApiDatabase from 'server';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';

/**
 * Confirming the generation of a contract (JBWEB-1138).
 *
 * Generating is what ends the period during which the mission can be edited
 * freely: from then on every change goes through an amendment. Before the
 * planned date that is a forcing, and the modal says so; from it, it is the
 * expected action and the confirmation is a plain one.
 */
const ModalContractGeneration = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem('xsrfToken');

  const isDue = Boolean(modalData?.isDue);
  const generationLabel = modalData?.generationLabel;

  const confirm = () => {
    if (isLoading) return;
    setIsLoading(true);

    ApiDatabase.requestGenerationContract(
      { token, idMission: modalData?.idMission },
      () => {
        setIsLoading(false);
        toast.success('La génération du contrat a bien été effectuée');
        setModalDataReturn({ type: 'contract_generated' });
        toggle();
      },
      (err) => {
        setIsLoading(false);
        if (err.name === 'CanceledError') return;
        toast.error(
          'Une erreur est survenue lors de la génération du contrat : ' +
            (err?.response?.data?.error ??
              err?.response?.data?.message ??
              'erreur inconnue')
        );
      }
    );
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        {isDue ? 'Générer le contrat' : 'Forcer la génération du contrat'}
      </Modalheader>
      <ModalBody>
        <div className={'text-gray-500'}>
          {isDue ? (
            // What the question is for: generating is what closes the period
            // during which the mission can still be edited freely.
            <>
              Êtes-vous sûr de générer le contrat de cette mission ? Une fois le
              contrat généré, toute modification de la mission devra passer par
              un avenant.
            </>
          ) : (
            <>
              Êtes-vous sûr de forcer la génération du contrat ? La génération
              est prévue le {generationLabel}. Tant que le contrat n'est pas
              généré, vous pouvez modifier la mission librement.
            </>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          Annuler
        </Button>
        <Button
          size={'LG'}
          color={isLoading ? 'DISABLED' : 'PRIMARY'}
          onClick={isLoading ? undefined : confirm}
        >
          {isLoading ? 'Génération ...' : 'Confirmer'}
        </Button>
      </ModalFooter>
    </>
  );
};

export default ModalContractGeneration;
